/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { constants as L100Constants } from '../../constants'
import $ from 'jquery'
// eslint-disable-next-line lodash-fp/use-fp, lodash-fp/consistent-name
import { size } from 'lodash'
import React, { Component, Fragment } from 'react'
import ReactHtmlParser from 'html-react-parser'
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { VISIT_URL } from '../../api/endpoints'
import Button from '../../components/Button'
import Spinner from '../../components/Spinner'
import config from '../../config/app'
import * as actionCreators from '../../root/actions'
import style from './style'

class Terms extends Component {
  state = {
    areTermsChecked: false,
    isSubmitting: false
  }

  render() {
    const { app } = this.props.containers

    return (
      <Fragment>
        {this.props.api.get('isLoading') && app.get('isMobile') ? (
          <Spinner />
        ) : (
          this.renderView()
        )}
      </Fragment>
    )
  }

  renderView() {
    const { areTermsChecked } = this.state
    const { classes, api } = this.props

    const onClick = () => this.bookAppointment()

    const bookBtnProps = {
      scheme: 'dark',
      disabled: !areTermsChecked,
      onClick,
      fixed: "true"
    }

    const btnMsg = 'Confirm Appointment'

    return (
      <div className={`${classes.base} mobile-padding`}>
        <h2 className={`${classes.titleContainer}`}>Terms of Service</h2>
        <div className={classes.agreementContainer}>
          <h4>{ReactHtmlParser(config.terms.agreement)}</h4>
          {!api.get('isLoading') ? (
            <div className={classes.acceptContainer}>
              <div className={classes.termsLabel}>
                <input
                  onChange={() => this.onChange()}
                  type="checkbox"
                  id="terms-checkbox"
                  checked={areTermsChecked}
                  required
                />
                <label htmlFor="terms-checkbox">
                  I accept the terms of service
                </label>
              </div>

              <Button {...bookBtnProps}>{btnMsg}</Button>
            </div>
          ) : (
            <Fragment>
              <br />
              <br />
              <br />
              <br />

              <Spinner />
            </Fragment>
          )}
        </div>
      </div>
    )
  }

  componentWillUnmount() {
    this.props.setProgressBarPercent(0) // reset progress bar
  }

  UNSAFE_componentWillMount() {
    const { changeRoute, containers } = this.props
    const { schedule } = containers

    if (schedule.get('selectedTimeslot') === null) changeRoute({ route: '/' })
  }

  componentDidMount() {
    this.props.setProgressBarPercent(75)
    $('.main-content').scrollTop(0)
  }

  onChange() {
    this.setState(prevState => {
      return {
        areTermsChecked: !prevState.areTermsChecked
      }
    })
  }

  bookAppointment() {
    if (this.state.isSubmitting) return
    this.setState({ isSubmitting: true })
    const {
      apiRequest,
      containers,
      changeRoute,
      getUserFromDBAndUpdateStore
    } = this.props
    const { schedule, payment, app } = containers
    const date = schedule.get('selectedTimeslot').time
    const paymentData = payment.get('paymentData')

    const data = {
      paymentData,
      date
    }

    const request = {
      url: VISIT_URL,
      method: 'post',
      data
    }

    const meta = {
      Component: 'Payment',
      isIgnoreSuccessReset: true,
      onError: () => {
        this.setState({ isSubmitting: false })
        changeRoute({ route: '/upcoming/schedule' })
      },
      onSuccess: result => {
        this.props.setProgressBarPercent(100)

        getUserFromDBAndUpdateStore({
          onError: () => this.setState({ isSubmitting: false }),
          onSuccess: () => {
            if (size(app.get('history')) > 0) {
              this.props.setUpcomingVisitAssessmentsNotice(true)
            }

            const { uuid } = result.data.data

            const hasSubmittedConsent =
              app.get('user').consent.accepted !== L100Constants.notSet

            const route = !hasSubmittedConsent
              ? `/visits/${uuid}/assessments/consent`
              : '/'
            this.props.selectTimeslot(null)
            this.props.validatePayment(false)
            this.setState({ isSubmitting: false }, () => changeRoute({ route }))
          }
        })
      }
    }

    apiRequest(request, meta)
  }
}

const mapStateToProps = state => {
  const { containers, api } = state

  return {
    containers,
    api
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}
const styleAndTheme = () => style

// @ts-ignore
export default injectSheet(styleAndTheme)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Terms)
)
